const getCurrentDateTime = () => {
  const time = new Date().toLocaleTimeString();
  return time.toString();
};
export { getCurrentDateTime };
